import React, { useState, useMemo } from 'react'
import NavBar from '@commonComponents/NavBar'
import { DutyMenuItems } from '../../../../util'
import RepeatableItemsContainer from '@containers/repeatableItemsContainer'
import MerchandiseDutyDetail from './MerchandiseDutyDetail'

const MerchandiseDuty = ({ merchandiseId, translate, ...rest }) => {

  const [tableName, setTableName] = useState('merchandiseDuty')

  const onDutyTaxNavbarChange = (itemNavbar) => setTableName(itemNavbar?.slug)

  const tableNameActive = useMemo(() => tableName, [tableName])

  return (
    <RepeatableItemsContainer
      {...rest}
      tableName={tableNameActive}
      // tableName='merchandiseDuty'
      merchandiseId={merchandiseId}
      reducerName='invoiceReducer'
      additionalComponent={<NavBar MenuItems={DutyMenuItems} triggerAction={onDutyTaxNavbarChange} />}
      title='DUTIES/TAXES'
      translate={translate}
      renderForm={(params) => <MerchandiseDutyDetail {...params} />}
    />
  )

}

export default React.memo(MerchandiseDuty)
